import { Form, Modal, Select } from 'antd';
import { DefaultOptionType } from 'antd/lib/select';
import _ from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import IInvestor from '~Api/Investor/IInvestor';
import {
    investorReferralsAddAction,
    investorsSearchAction,
    investorsSearchResultsClearAction,
} from '~Investors/actions';
import { investorsSearchResultsSelector } from '~Investors/selectors';
import { IGlobalState } from '~reducer';
import { IDictionary } from '~utilities/IDictionary';

interface IState {
    referralInvestorUuid: string;
}

interface IProps {
    investorUuid: string;
    isOpen: boolean;
    onCancel: () => void;
}

interface IPropsSelector {
    investorsSearchResults: IDictionary<IInvestor>;
}

interface IPropsDispatch {
    investorsSearch: (keyword: string) => void;
    investorsSearchResultsClear: () => void;
    referralAdd: (referralInvestorUuid: string) => void;
}

type Props = IProps & IPropsSelector & IPropsDispatch;

class ReferralAddModal extends React.Component<Props, IState> {
    public state: IState = {
        referralInvestorUuid: null,
    };

    constructor(props: Props) {
        super(props);

        this.onCancel = this.onCancel.bind(this);
        this.onChangeReferralInvestorId = this.onChangeReferralInvestorId.bind(this);
        this.onClickOk = this.onClickOk.bind(this);
        this.onSearchInvestor = this.onSearchInvestor.bind(this);
    }

    public render(): JSX.Element {
        const {
            investorsSearchResults,
            isOpen,
        } = this.props;

        const investorOptions: DefaultOptionType[] = _.map(investorsSearchResults, (investor: IInvestor) => ({
            label: investor.name,
            value: investor.uuid,
        }));

        return (
            <Modal
                destroyOnClose={true}
                onCancel={this.onCancel}
                onOk={this.onClickOk}
                open={isOpen}
                title='Add Referral'
            >
                <Form.Item label='Investor' className='referralInvestorId'>
                    <Select
                        allowClear={true}
                        filterOption={false}
                        notFoundContent={null}
                        onChange={this.onChangeReferralInvestorId}
                        onSearch={this.onSearchInvestor}
                        options={investorOptions}
                        placeholder='None'
                        showArrow={false}
                        showSearch={true}
                    />
                </Form.Item>
            </Modal>
        );
    }

    private onChangeReferralInvestorId(value: string): void {
        this.setState({
            referralInvestorUuid: value,
        });

        this.props.investorsSearchResultsClear();
    }

    private onCancel(): void {
        this.props.investorsSearchResultsClear();
        this.props.onCancel();
    }

    private onClickOk(): void {
        const { referralInvestorUuid } = this.state;

        this.props.referralAdd(referralInvestorUuid);
        this.props.investorsSearchResultsClear();
        this.props.onCancel();
    }

    private onSearchInvestor(search: string): void {
        this.props.investorsSearch(search);
    }
}

function mapStateToProps(state: IGlobalState): IPropsSelector {
    return {
        investorsSearchResults: investorsSearchResultsSelector(state),
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: IProps): IPropsDispatch {
    return {
        investorsSearch: (keyword: string) => dispatch(investorsSearchAction(keyword)),
        investorsSearchResultsClear: () => dispatch(investorsSearchResultsClearAction()),
        referralAdd: (referralInvestorUuid: string) => dispatch(investorReferralsAddAction(ownProps.investorUuid, referralInvestorUuid)),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ReferralAddModal);
